
import * as React from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

interface AddObjectiveFormProps {
  value: string;
  onChange: (value: string) => void;
  onAdd: () => void;
}

const AddObjectiveForm = ({ value, onChange, onAdd }: AddObjectiveFormProps) => {
  return (
    <div className="flex items-center gap-2 px-2 py-2 border-b border-gray-200">
      <Input
        placeholder="Add new objective"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="h-8 text-sm"
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            onAdd();
          }
        }}
      />
      <Button 
        size="sm" 
        variant="ghost" 
        className="h-8 px-2" 
        onClick={onAdd}
      >
        <Plus className="w-4 h-4" />
      </Button>
    </div>
  );
};

export default AddObjectiveForm;
